import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';
const Piechart = (props) => {


    const state = {

        series: [44, 55, 23, 43],
        options: {
            chart: {
                width: 380,
                type: 'pie',
            },
            labels: ['USA', 'UK', 'Australia ', 'Europe'],
            legend: {
                position: 'bottom',
                markers: {
                    fillColors: ['#FD7B5D', '#FF8954', '#FF9847', '#FF9B44']
                }
            },
            fill: {
                colors: ['#FD7B5D', '#FF8954', '#FF9847', '#FF9B44']
            },
            dataLabels: {
                enabled: false
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: "100%"
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
    }


    return (
        <div>
            <div id="chart">
                <ReactApexChart options={state.options} series={state.series} type="pie" width="100%" />
            </div>
        </div >
    );
}


export default Piechart;
